module.exports = __webpack_public_path__ + "static/img/mobel@2x.05ad66cd.png";